export enum WhatsappSendToEnum{
    Associates = 'Associates',
    Vendors = 'Vendors',
    Customers = 'Customers',
}